import { requester } from '../utils';

export const getCitiesList = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/city?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch city list error', err);
        reject(err);
      });
  });
};

export const getCityById = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/city/${id}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch city error', err);
        reject(err);
      });
  });
};

export const updateCity = (reqObject, id) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/city/${id}`,
        method: 'PUT',
        data: reqObject,
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('update city error', err);
        reject(err);
      });
  });
};

export const addNewCity = reqObject => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/city`,
        method: 'POST',
        data: reqObject,
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('add new city error', err);
        reject(err);
      });
  });
};